import { render, staticRenderFns } from "./PanelMoreLess.vue?vue&type=template&id=3df4cabe&scoped=true&"
import script from "./PanelMoreLess.vue?vue&type=script&lang=js&"
export * from "./PanelMoreLess.vue?vue&type=script&lang=js&"
import style0 from "./PanelMoreLess.vue?vue&type=style&index=0&id=3df4cabe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df4cabe",
  null
  
)

export default component.exports